import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const P7mFileImage = (t0)=>{
    const $ = c(9);
    const { width, height } = t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.4064 5H35.5L48.9999 18.8V45.0115C48.9999 48.3218 46.1974 50.9999 42.7453 50.9999H19.2666C15.8025 50.9999 13 48.3218 13 45.0115V10.9884C12.9999 7.6781 15.9423 5 19.4064 5Z",
            fill: "#E2E6EB"
        });
        t2 = /*#__PURE__*/ jsx("path", {
            d: "M35.5289 14.384V5L48.9999 18.8L40.0192 18.8C35.9779 18.8 35.3418 15.856 35.5289 14.384Z",
            fill: "#BAC6D1"
        });
        t3 = /*#__PURE__*/ jsx("path", {
            d: "M7 33C7 30.7909 8.79086 29 11 29H38C40.2091 29 42 30.7909 42 33V43C42 45.2091 40.2091 47 38 47H11C8.79086 47 7 45.2091 7 43V33Z",
            fill: "#9D22FE"
        });
        t4 = /*#__PURE__*/ jsx("path", {
            d: "M27.4499 33.2728H29.9151L32.5188 39.625H32.6296L35.2333 33.2728H37.6985V42.7273H35.7595V36.5736H35.6811L33.2343 42.6812H31.914L29.4673 36.5505H29.3888V42.7273H27.4499V33.2728Z",
            fill: "white"
        });
        t5 = /*#__PURE__*/ jsx("path", {
            d: "M20.037 42.7273L23.9564 34.9716V34.907H19.3907V33.2728H26.0245V34.9301L22.1005 42.7273H20.037Z",
            fill: "white"
        });
        t6 = /*#__PURE__*/ jsx("path", {
            d: "M11.3014 42.7273V33.2728H15.0316C15.7487 33.2728 16.3596 33.4097 16.8643 33.6836C17.369 33.9545 17.7537 34.3315 18.0184 34.8147C18.2862 35.2948 18.4201 35.8488 18.4201 36.4766C18.4201 37.1044 18.2846 37.6584 18.0138 38.1385C17.743 38.6187 17.3506 38.9926 16.8366 39.2603C16.3257 39.5281 15.7071 39.662 14.9808 39.662H12.6033V38.0601H14.6576C15.0423 38.0601 15.3593 37.9939 15.6086 37.8615C15.861 37.7261 16.0487 37.5399 16.1718 37.303C16.298 37.0629 16.3611 36.7874 16.3611 36.4766C16.3611 36.1627 16.298 35.8888 16.1718 35.6549C16.0487 35.4179 15.861 35.2348 15.6086 35.1055C15.3563 34.9732 15.0362 34.907 14.6484 34.907H13.3004V42.7273H11.3014Z",
            fill: "white"
        });
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = t6;
    } else {
        t1 = $[0];
        t2 = $[1];
        t3 = $[2];
        t4 = $[3];
        t5 = $[4];
        t6 = $[5];
    }
    let t7;
    if ($[6] !== height || $[7] !== width) {
        t7 = /*#__PURE__*/ jsxs("svg", {
            width: width,
            height: height,
            viewBox: "0 0 56 56",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t1,
                t2,
                t3,
                t4,
                t5,
                t6
            ]
        });
        $[6] = height;
        $[7] = width;
        $[8] = t7;
    } else t7 = $[8];
    return t7;
};
export { P7mFileImage };
